import type { ReactElement, ReactNode } from "react";
import { Tab, TabbedShowLayoutProps, TabProps } from "react-admin";
import { NewDesignTabbedShowLayout } from "./NewDesignTabbedShowLayout";

type TabElement = ReactElement<TabProps, typeof Tab>;

type TabsProps = {
  header?: ReactNode;
  additionalButtons?: ReactNode;
  mobileSelectAriaLabel?: string;
  children: Array<TabElement | false | undefined | null>;
  separateCards?: boolean;
  fullWidth?: boolean;
  syncWithHash?: boolean;
  style?: React.CSSProperties;
  onTabChange?: (activeTab: ReactElement) => void;
} & Omit<TabbedShowLayoutProps, "tabs">;

export function Tabs(props: TabsProps) {
  const { header, additionalButtons, separateCards, fullWidth = false, children, ...rest } = props;
  return (
    <NewDesignTabbedShowLayout
      header={header}
      additionalButtons={additionalButtons}
      tabs={children}
      separateCards={separateCards}
      fullWidth={fullWidth}
      {...rest}
    />
  );
}
